import { resolveFleetNotificationLink } from '../utils/fleetNotificationLink';
import { shouldShowPageNotification } from './desktopNotify.gate';
import { getFleetNotifyPrefs, categoryOfType } from '../utils/fleetNotifyPrefs';

export const FLEET_WEBPUSH_TOKEN_KEY = 'fleet-webpush-token';

/* ── Leader sekme kilidi ───────────────────────────────────────────────────
   Filo yöneticisi paneli iki sekmede açtığında bildirim ve toast BİR kez çıksın.
   Web Locks yoksa (eski tarayıcı) her sekme lider sayılır — çift bildirim,
   hiç bildirim olmamasından iyidir. */
let isLeader = false;
let lockRequested = false;

export function initFleetLeaderLock(fleetId) {
    if (lockRequested) return;
    lockRequested = true;

    if (typeof navigator === 'undefined' || !navigator.locks) {
        isLeader = true;
        return;
    }

    const key = `hizliyo-fleet-leader:${fleetId || 'anon'}`;
    /* try/catch çağrının KENDİSİNİ sarar, yalnız dönen sözü değil: navigator.locks.request
       senkron da fırlatabilir (geçersiz ad, güvenli olmayan bağlam, tarayıcı hatası). Bu
       çağrı App.jsx'in oturum efektinde setupFleetWebPush, yönlendirici ve altı SignalR
       dinleyicisinden ÖNCE duruyor; uygulamanın hata sınırı da yok — buradan kaçan bir
       istisna paneli tümüyle boş bırakırdı. */
    try {
        navigator.locks
            .request(key, { mode: 'exclusive' }, () => {
                isLeader = true;
                // Kilit, sekme kapanana kadar tutulur: söz asla çözülmez.
                return new Promise(() => {});
            })
            .catch(() => { isLeader = true; });
    } catch {
        // Web Locks yokmuş gibi davran: her sekme lider (mevcut fallback ile aynı).
        isLeader = true;
    }
}

export function getIsFleetLeader() {
    return isLeader;
}

/* ── İzin ve web push durumu ─────────────────────────────────────────────── */

export function getNotificationPermission() {
    if (typeof window === 'undefined' || !('Notification' in window)) return 'unsupported';
    return Notification.permission;
}

export async function requestNotificationPermission() {
    if (typeof window === 'undefined' || !('Notification' in window)) return 'unsupported';
    try {
        return await Notification.requestPermission();
    } catch {
        return Notification.permission;
    }
}

/* Web push etkin mi? Token varlığı service worker'ın bildirimi çizeceğinin işaretidir. */
export function isWebPushActive() {
    if (getNotificationPermission() !== 'granted') return false;
    try {
        return !!window.localStorage.getItem(FLEET_WEBPUSH_TOKEN_KEY);
    } catch {
        return false;
    }
}

/* ── Bildirim çizimi ─────────────────────────────────────────────────────── */

export function showFleetDesktopNotification({ type, title, body, force = false }) {
    const permission = getNotificationPermission();
    const prefs = getFleetNotifyPrefs();
    const category = categoryOfType(type);

    const allowed = shouldShowPageNotification({
        permission,
        hasWebPushToken: isWebPushActive(),
        isLeader: getIsFleetLeader(),
        prefEnabled: prefs[category] === true,
        force,
    });

    if (!allowed) return;

    const link = resolveFleetNotificationLink(type);

    try {
        const n = new Notification(title, {
            body,
            /* tag: aynı tipin arka arkaya gelen bildirimleri üst üste binsin, ekranı doldurmasın */
            tag: `hizliyo-fleet-${type || 'general'}`,
            icon: '/icon-192.png',
            badge: '/icon-192.png',
            /* Filo yöneticisi ekranın başında olmayabilir; bildirim kendiliğinden kaybolmamalı. */
            requireInteraction: true,
        });

        n.onclick = () => {
            window.focus();
            window.location.assign(link);
            n.close();
        };
    } catch {
        /* Bildirim çizilemedi (izin iptal edildi, kota vs.) — toast ve zil zaten çalıştı. */
    }
}
